/**
 * Botón de acción inline para filas (editar / borrar / duplicar).
 *
 * Icono SVG obligatorio (regla frontend: nunca emoji ni librerías externas).
 * Tamaño 28x28 para no romper el alto de fila canónico.
 */

import { useState, type ReactNode } from 'react';
import { ADMIN_TOKENS } from './adminTokens';

interface AdminActionButtonProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  variant?: 'default' | 'danger';
  disabled?: boolean;
}

export function AdminActionButton({
  icon,
  label,
  onClick,
  variant = 'default',
  disabled = false,
}: AdminActionButtonProps) {
  const [hover, setHover] = useState(false);

  const style: React.CSSProperties = {
    ...ADMIN_TOKENS.actionButton.root,
    ...(hover && !disabled ? ADMIN_TOKENS.actionButton.hover : {}),
    ...(variant === 'danger' ? ADMIN_TOKENS.actionButton.danger : {}),
    ...(disabled ? { opacity: 0.4, cursor: 'not-allowed' } : {}),
  };

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick();
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      disabled={disabled}
      style={style}
    >
      {icon}
    </button>
  );
}
